import React from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BaggageClaim } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function FloatingCart() {
    const { count, setCartOpen, cartOpen } = useStore();
    const location = useLocation();

    const hidden = cartOpen || location.pathname.startsWith("/checkout") || location.pathname.startsWith("/payment");

    return (
        <AnimatePresence>
            {!hidden && (
                <motion.button
                    data-testid="floating-cart-button"
                    data-cursor="BAG"
                    onClick={() => setCartOpen(true)}
                    aria-label="Open bag"
                    initial={{ opacity: 0, scale: 0.5, y: 30 }}
                    animate={{ opacity: 1, scale: 1, y: [0, -7, 0] }}
                    exit={{ opacity: 0, scale: 0.5, y: 30 }}
                    whileHover={{ scale: 1.1, rotate: -4 }}
                    whileTap={{ scale: 0.88 }}
                    transition={{
                        default: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
                        y: { duration: 3.2, repeat: Infinity, ease: "easeInOut" },
                    }}
                    className="fixed bottom-4 right-4 z-[120] flex h-14 w-14 items-center justify-center rounded-full border border-[rgba(10,10,10,0.22)] bg-[#F2F0EA] text-[#0A0A0A] shadow-[0_18px_40px_-10px_rgba(0,0,0,0.9),0_6px_16px_-6px_rgba(0,0,0,0.7),inset_0_2px_3px_rgba(255,255,255,0.15),inset_0_-4px_8px_rgba(0,0,0,0.6)] md:bottom-7 md:right-7"
                    style={{ transformStyle: "preserve-3d" }}
                >
                    <BaggageClaim size={19} strokeWidth={1.8} />
                    <AnimatePresence>
                        {count > 0 && (
                            <motion.span
                                key={count}
                                data-testid="floating-cart-count"
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                exit={{ scale: 0 }}
                                transition={{ type: "spring", stiffness: 500, damping: 22 }}
                                className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#0A0A0A] px-1 text-[10px] font-bold text-[#F2F0EA] shadow-[0_4px_10px_rgba(0,0,0,0.6)]"
                            >
                                {count}
                            </motion.span>
                        )}
                    </AnimatePresence>
                </motion.button>
            )}
        </AnimatePresence>
    );
}
